import { motion } from "framer-motion";

// Fade-up + blur-in entrance used across sections.
export const Reveal = ({ children, delay = 0, y = 40, className = "", as }) => {
  const Comp = motion[as || "div"];
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y, filter: "blur(10px)" }}
      whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </Comp>
  );
};

export default Reveal;
